export const reviewerInitials = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');

export const reviewerAvatarHue = (name: string): number => {
  const normalized = name.trim().toLowerCase() || 'guest';
  const hash = [...normalized].reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return 18 + (hash % 300);
};
